import { ModalCenterInPage } from 'shared/components';

import { useSFCancelOrderModal } from './hooks';

import makeClasses from './SFCancelOrderModal.style';

export function SFCancelOrderModal() {
  const {
    lang,
    isOpen,
    orderId,
    handleClose,
    handleSend,
  } = useSFCancelOrderModal();

  const _classes = makeClasses();

  if (isNaN(orderId)) return null;
  return (
    <ModalCenterInPage
      open={isOpen}
      onClose={handleClose}
      title={lang.title}
      data-order-id={orderId}
      aria-label='substitution-flow-cancel-order'
      paragraphs={{
        first: lang.paragraph.first,
        second: lang.paragraph.second,
      }}
      actions={{
        secondaryBtn: {
          children: lang.action.secondaryBtn.label,
          onClick: handleClose,
        },
        primaryBtn: {
          children: lang.action.primaryBtn.label,
          onClick: handleSend,
        },
      }}
      classes={{ main: _classes.main }}
    />
  );
}
